import {
    APP_BUSY_DECREMENT,
    APP_BUSY_INCREMENT
} from '..'

export default class AppBusy {

    static _dispatch(event, why) {
        return (dispatch) => {
            return dispatch({
                type: event,
                why
            })
        }
    }

    static moreBusy(why) {
        return this._dispatch(APP_BUSY_INCREMENT, why)
    }

    static lessBusy(why) {
        return this._dispatch(APP_BUSY_DECREMENT, why)
    }

}



// WEBPACK FOOTER //
// src/actions/app-busy/index.js